import apiClient from '@utils/apiClient';
import { GrowthCultivarListRes } from '@/api/growth/cultivar/type';

export const api = {
    /**
     * 생육품종목록
     * @param gcId
     */
    growthCultivarList: async (
        gcId: string,
    ): Promise<GrowthCultivarListRes> => {
        const response = await apiClient.get<GrowthCultivarListRes>(
            `/api/v1/growth/cultivar/list/${gcId}`,
        );
        return response.data;
    },
};
